import type { HourlyPlaysHour } from '@/types/content';

const parsedHour = (hourUtc: string): number => {
  const parsed = Date.parse(hourUtc);
  if (Number.isNaN(parsed)) {
    throw new Error('Live downloads chart requires a valid hour');
  }
  return parsed;
};

/** Local midnight today through the next local midnight, in epoch milliseconds. */
export const localTodayBounds = (now = new Date()) => {
  const dayStartDate = new Date(now);
  dayStartDate.setHours(0, 0, 0, 0);
  const dayEndDate = new Date(dayStartDate);
  dayEndDate.setDate(dayEndDate.getDate() + 1);

  return { dayStart: dayStartDate.getTime(), dayEnd: dayEndDate.getTime() };
};

/** 00:00, 06:00, 12:00, and 18:00 on the local calendar day, in epoch milliseconds. */
export const localDayTicks = (now = new Date()): number[] => {
  const { dayStart } = localTodayBounds(now);
  const midnight = new Date(dayStart);

  return [0, 6, 12, 18].map((hour) => {
    const tick = new Date(midnight);
    tick.setHours(hour, 0, 0, 0);
    return tick.getTime();
  });
};

/** End of the closed hour. */
export const closedHourEnd = (hourStartMs: number): number => hourStartMs + 60 * 60 * 1000;

/** Hours whose UTC instant falls on the current local calendar day. */
export const hoursOnLocalToday = (
  hours: HourlyPlaysHour[],
  now = new Date()
): HourlyPlaysHour[] => {
  const { dayStart, dayEnd } = localTodayBounds(now);
  return hours.filter((row) => {
    const instant = parsedHour(row.hour_utc);
    return instant >= dayStart && instant < dayEnd;
  });
};
